const config = {
    api_base_url: "https://stag-api.isrc.app/v1",
    site_base_url: "https://stag-admin.isrc.app",
    orb_auth_url: "https://stag-auth.orbmusic.com.br?app=58b09aaa16e1f7eda1cc8829f7ca64268eda4d46556b9bd00b19cd6785c90506",
    orb_logout_url: "https://stag-auth.orbmusic.com.br/logout?app=58b09aaa16e1f7eda1cc8829f7ca64268eda4d46556b9bd00b19cd6785c90506"
}

export default config;
